<div class="maintenance">
  <div class="maintenance-alert bg-white">
    <img src="assets/gears.svg" alt="">
    <h1 class="text-center">{{ 'shared:maintenance.thisPageIsUnderScheduledMaintenance' | i18next }}</h1>
    <div class="maintenance-timer background-light py-3 w-100 mb-4" *ngIf="diff > 0">
      <div [ngClass]="{'border-0' : diff <= 0, 'mb-3' : diff > 0}" class="maintenance-timer-remaining ">
        <div class="text-gray-600 text-center text-lg">
          {{ 'shared:maintenance.pageWillBeUpdatedIn' | i18next }}
        </div>
        <h1 class="m-0 text-center">
          {{ remainingTime | async }}
        </h1>
      </div>
      <div class="maintenance-timer-info d-flex align-items-center justify-content-around pt-3">
        <div>
          {{ 'shared:maintenance.localTime' | i18next: { date: dates.now | date: 'h:mm a' } }}
        </div>
        <div>
          {{ 'shared:maintenance.EST' | i18next: { date: dates?.est | date: 'h:mm a' } }}
        </div>
        <div>
          {{ 'shared:maintenance.UTC' | i18next: { date: dates?.utc | date: 'h:mm a' } }}
        </div>
      </div>

    </div>
    <div [innerHTML]="'shared:maintenance.checkPageStatusOn' | i18next"></div>
  </div>
</div>
